import { withCompInfo } from '../../core/withCompInfo'
import {
	PaginatedGridGalleryProps,
	PaginatedGridGalleryCarmiData,
	PaginatedGridGalleryCSSVars,
	PaginatedGridGalleryDefinition,
} from './types'
import { getRowHeight } from '../../core/galleriesCommon/gridCalculations'

const MIN_HEIGHT = 70

export const props = withCompInfo<
	PaginatedGridGalleryProps,
	PaginatedGridGalleryDefinition,
	PaginatedGridGalleryCarmiData
>(['skin', 'compProps'], ({ skin, compProps }, carmiData) => {
	const {
		maxRows: rows,
		numCols: columns,
		galleryImageOnClickAction,
		autoplay: autoPlay,
		showNavigation,
		showAutoplay,
		showCounter,
		transition,
		goToLinkText,
	} = compProps
	const hasTransition = transition !== 'none'
	const transitionDuration = compProps.transDuration * 1000
	const autoPlayInterval = compProps.autoplayInterval * 1000 + (hasTransition ? transitionDuration : 0)

	return {
		skin,
		rows,
		columns,
		items: carmiData.itemsProps,
		imageOnClickAction: galleryImageOnClickAction,
		transition,
		transitionDuration,
		autoPlay,
		autoPlayInterval,
		showNavigation,
		showAutoplay,
		showCounter,
		reducedMotion: false,
		currentPage: 0,
		goToLinkText: goToLinkText || 'Go to link',
	}
})

const skinBottomPaddingMap = {
	PaginatedGridDefaultSkin: 0,
	PaginatedGridOverlay: 0,
	PaginatedGridArrowsOutside: 20,
	PaginatedGridRibbonArrows: 20,
	PaginatedGridTextBottom: 60,
} as const

export const css = withCompInfo<PaginatedGridGalleryCSSVars, PaginatedGridGalleryDefinition>(
	['skin', 'compProps', 'compLayout'],
	({ skin, compProps, compLayout }) => {
		const { height = MIN_HEIGHT } = compLayout
		const { margin, maxRows: rows, numCols: columns } = compProps
		const galleryBottomPadding = skinBottomPaddingMap[skin]

		const rowHeight = getRowHeight(height, margin, rows, galleryBottomPadding)

		return {
			height: 'auto',
			'--number-of-columns': columns,
			'--spacing': `${margin}px`,
			'--row-height': `${rowHeight}px`,
			'--gallery-bottom-padding': `${galleryBottomPadding}px`,
		}
	}
)
